import { useState } from "react";
import { api } from "../api";
import { Gauge } from "../components/Strata";
import {
  Notice,
  Section,
  Spinner,
  discussions,
  msgs,
  ruDate,
  useAsync,
} from "../components/common";

export function TopicsTab({ onOpenThread }: { onOpenThread: (id: number) => void }) {
  const [slug, setSlug] = useState<string | null>(null);
  const list = useAsync(() => api.topics(), []);
  const detail = useAsync(() => (slug ? api.topic(slug) : Promise.resolve(null)), [slug]);

  if (slug) {
    return (
      <>
        <button className="back" onClick={() => setSlug(null)}>
          ← все темы
        </button>
        {detail.loading && <Spinner />}
        {detail.data && (
          <>
            <div className="screen-head">
              <div className="rail">{detail.data.topic.slug}</div>
              <h1 style={{ fontSize: 23 }}>{detail.data.topic.name}</h1>
              {detail.data.topic.description && <p>{detail.data.topic.description}</p>}
            </div>
            <Section>
              {detail.data.threads.map((t) => (
                <button
                  key={t.root_msg_id}
                  className="row"
                  onClick={() => onOpenThread(t.root_msg_id)}
                >
                  <div className="row-title">{t.title}</div>
                  {t.summary && <div className="row-sub">{t.summary}</div>}
                  <div className="row-meta">
                    <span>{ruDate(t.started_at)}</span>
                    <span className="sep">/</span>
                    <span>{msgs(t.msg_count)}</span>
                    {t.author && (
                      <>
                        <span className="sep">/</span>
                        <span>{t.author}</span>
                      </>
                    )}
                    {t.quality != null && <Gauge value={t.quality} />}
                  </div>
                </button>
              ))}
            </Section>
          </>
        )}
      </>
    );
  }

  return (
    <>
      <div className="screen-head">
        <div className="rail">рубрикатор</div>
        <h1>Темы</h1>
        <p>Выведены из восьми лет переписки, а не придуманы заранее</p>
      </div>
      {list.loading && <Spinner />}
      {list.error && <Notice>{list.error}</Notice>}
      {list.data && list.data.length === 0 && (
        <Notice>
          Рубрикатор ещё не построен. Запустите <code>python -m ingest.build_taxonomy</code>,
          затем <code>python -m ingest.enrich_threads</code>.
        </Notice>
      )}
      {list.data?.map((parent) => (
        <Section key={parent.slug} title={`${parent.name} · ${discussions(parent.total_threads)}`}>
          {parent.description && (
            <div
              style={{
                padding: "0 16px 12px",
                fontSize: 13.5,
                color: "var(--text-dim)",
                lineHeight: 1.45,
              }}
            >
              {parent.description}
            </div>
          )}
          {/* Busiest subtopics first, and empty ones dimmed rather than hidden:
              a topic with nothing in it yet is a fact about how far the
              enrichment pass has got, not a mistake to conceal. */}
          {[...parent.children]
            .sort((a, b) => b.thread_count - a.thread_count)
            .map((child) => (
              <button key={child.slug} className="row" onClick={() => setSlug(child.slug)}>
                <div className="row-title">{child.name}</div>
                <div
                  className={`row-meta${child.thread_count === 0 ? " row-meta--muted" : ""}`}
                >
                  <span>{discussions(child.thread_count)}</span>
                </div>
              </button>
            ))}
          <button className="row" onClick={() => setSlug(parent.slug)}>
            <div className="row-meta" style={{ marginTop: 0, color: "var(--teal)" }}>
              <span>всё по теме «{parent.name}» →</span>
            </div>
          </button>
        </Section>
      ))}
    </>
  );
}
